import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Tabs } from 'antd';
import OpenTrades from '../dashboard/components/OpenTrades';
import CloseTrades from '../dashboard/components/ClosedTrades';

const Trades = () => {
  const { loginId } = useParams();
  const [activeTab, setActiveTab] = useState('open');

  const items = [
    {
      key: 'open',
      label: 'Open Trades',
      children: <div className="mb-4"><OpenTrades loginId={loginId}/></div>,
    },
    {
      key: 'closed',
      label: 'Closed Trades',
      children: <CloseTrades loginId={loginId} />,
    },
  ];

  return (
    <div className="border-2 border-light rounded-[10px] h-full">
      <Tabs
        defaultActiveKey="open"
        items={items}
        onChange={(key) => setActiveTab(key)}
        className="px-6"
      />
    </div>
  );
};

export default Trades;
